import React from 'react';
import { CheckCircle2, Circle, CircleAlert } from 'lucide-react';

/**
 * Giriş Adresleri kılavuzunun üstündeki kontrol listesi: kurulumun o anki
 * durumunu kılavuzun adımlarıyla eşler ("yayında adres var mı, engellenince
 * geçilecek yedek hazır mı").
 *
 * Yalnızca ekranın zaten okuduğu `GET /admin/entry-domains` yanıtından
 * türetilir; ayrı bir istek yapmaz ve hiçbir şeyi değiştirmez.
 */
export const entryDomainChecks = (state) => {
  const domains = state.domains || [];
  const closed = new Set(state.closed_hosts || []);
  const mirrors = domains.filter((row) => row.kind !== 'gateway');
  const spares = mirrors.filter((row) => row.id !== state.active_id
    && row.status !== 'blocked' && !closed.has(row.host));
  const license = state.license || {};

  const checks = [
    {
      key: 'server',
      level: state.server?.configured ? 'done' : 'optional',
      title: 'Sunucu bağlantısı',
      text: state.server?.configured
        ? `${state.server.username}@${state.server.host} kayıtlı; adresler panelden kurulur.`
        : 'Girilmedi. "Sunucuya kur" için gerekir; sunucuyu elle yönetiyorsanız atlanabilir.',
    },
    {
      key: 'active',
      level: state.active_host ? 'done' : 'todo',
      title: 'Yayındaki adres',
      text: state.active_host
        ? `${state.active_host} — oyuncular buraya yönlendirilir.`
        : mirrors.length
          ? 'Yok. Listedeki adresler yayına alınana kadar siteyi açmaz.'
          : 'Liste boş; site bugünkü adresinde çalışmaya devam eder.',
    },
    {
      key: 'spare',
      level: spares.length ? 'done' : 'todo',
      title: 'Hazır yedek adres',
      text: spares.length
        ? `${spares.length} adres hazır (${spares.slice(0, 2).map((row) => row.host).join(', ')}${spares.length > 2 ? '…' : ''}).`
        : 'Yok. Yayındaki adres engellendiğinde hemen geçebilmek için en az bir yedek ekleyin.',
    },
    {
      key: 'notice',
      level: state.enabled ? 'done' : 'optional',
      title: 'Oyuncuya duyuru',
      text: state.enabled
        ? 'Footer\'da yayındaki adres yazıyor.'
        : 'Kapalı (isteğe bağlı). Yönlendirme bundan etkilenmez.',
    },
    {
      key: 'gateway',
      level: state.gateway_host ? 'done' : 'optional',
      title: 'Hızlı Giriş',
      text: state.gateway_host
        ? `${state.gateway_host} → ${state.active_host || 'yayında adres yok'}`
        : 'Tanımlı değil (isteğe bağlı). Oyunculara hiç değişmeyen bir adres verir.',
    },
  ];

  if (state.license_configured) {
    let text = 'Henüz eşitlenmedi; ilk yayına almada eşitlenir.';
    if (license.error) text = state.license_message || 'Lisans sunucusuna bildirilemedi.';
    else if (license.follows === true) text = 'Giriş adreslerine bağlı; yayına alınan adres lisansa da geçer.';
    else if (license.follows === false) text = 'Sabit bir adrese bağlı; giriş adresi lisansı etkilemez.';
    checks.push({
      key: 'license',
      level: license.error ? 'todo' : 'done',
      title: 'Lisans',
      text,
    });
  }
  return checks;
};

const ICONS = { done: CheckCircle2, todo: CircleAlert, optional: Circle };
const LEVEL_LABELS = { done: 'tamam', todo: 'eksik', optional: 'isteğe bağlı' };

const EntryDomainsStatus = ({ state }) => (
  <>
    <div className="admin-help-intro-title">Bu kurulumda durum</div>
    <ul className="admin-help-checks">
      {entryDomainChecks(state).map((item) => {
        const Icon = ICONS[item.level];
        return (
          <li key={item.key} className={item.level}>
            <Icon size={15} aria-hidden="true" />
            <span>
              <span className="sr-only">{`${LEVEL_LABELS[item.level]}: `}</span>
              <b>{item.title}:</b> {item.text}
            </span>
          </li>
        );
      })}
    </ul>
  </>
);

export default EntryDomainsStatus;
